(function() {
    'use strict';
    angular
        .module('bluebookApp')
        .factory('LabRequisitionSignature', LabRequisitionSignature);

    LabRequisitionSignature.$inject = ['$resource'];

    function LabRequisitionSignature ($resource) {
        var resourceUrl =  'api/lab-requisition-signatures/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
